import {DeepPartial} from 'utility-types';

import {isBoolean} from 'ramda-adjunct';

import {GetDirectSaleVariantResponse} from '@dms/api/warehouse';

import {Nullish} from 'shared/web';

import {WarehouseDirectSaleVariantsDetailFormSchemaType} from '../types/WarehouseDirectSaleVariantsDetailFormSchema';

type AccountingDefaultValues = NonNullable<
  DeepPartial<WarehouseDirectSaleVariantsDetailFormSchemaType>['accounting']
>;

// The radio group holds the flag as a string, so an unset flag starts on "VAT deductible".
const DEFAULT_IS_TAX_DEDUCTIBLE = 'true';

export function buildAccountingDefaultValues(
  accounting: GetDirectSaleVariantResponse['accounting'] | Nullish
): AccountingDefaultValues {
  const isTaxDeductible = accounting?.isTaxDeductible;

  return {
    ...accounting,
    isTaxDeductible: isBoolean(isTaxDeductible)
      ? isTaxDeductible.toString()
      : DEFAULT_IS_TAX_DEDUCTIBLE,
    excludedServiceCenterIds: accounting?.excludedServiceCenterIds ?? [],
    isDefaultServiceCenterLocked: accounting?.isDefaultServiceCenterLocked ?? false,
  };
}
